import React from "react";
import { styled } from "@linaria/react";
import { LIST_STYLE_HYPHEN } from "@ui";

interface P {
  explanations: string[];
}

const ExplanationList = styled.ul`
  display: grid;
  gap: 4px;
  margin-left: 16px;
  margin-top: 4px;
`;

const ExplanationListItem = styled.li`
  &::marker {
    content: "${LIST_STYLE_HYPHEN} ";
  }
`;

function BannerTextList({ explanations }: P) {
  return (
    <ExplanationList>
      {explanations.map(exp => (
        <ExplanationListItem key={exp}>{exp}</ExplanationListItem>
      ))}
    </ExplanationList>
  );
}

export default React.memo(BannerTextList);
